export const TITLE_MAX_LENGTH = 50;
export const DESCRIPTION_MAX_LENGTH = 200;
export const GOAL_MIN_VALUE = 1;
export const GOAL_MAX_VALUE = 1e10 - 1;
